import { useContext, useEffect } from "react";
import Dashboard from "../Pages/Dashboard";
import Tryps from "../Pages/Tryps";
import Stats from "../Pages/Stats";
import LevelUp from "../Pages/LevelUp";
import SafeRoads from "../Pages/SafeRoads/SafeRoads";
import { GlobalContext } from "../common/Context";
import PageWrapper from "../common/PageWrapper";
import SponsorZone from "../Pages/SponsorZone/SponsorZone";
import CompetitionInfo from "../Pages/CompetitionInfo/CompetitionInfo";
import { PREMIUM_PAGES } from "../../constants";

const Home = () => {
  const {
    optionState,
    setOptionState,
    setNotFound,
    mobileView,
    tabletView,
    currentUser,
  } = useContext(GlobalContext);
  const mobileTablet = mobileView || tabletView;
  const ADMIN_PAGES = ["companyProfile", "videoAdmin", "adminPortal"];
  const freeUser = !currentUser.isAdmin && !currentUser.isViewer;
  setNotFound(false);

  useEffect(() => {
    if (ADMIN_PAGES.find((page) => page === optionState.nav)) {
      setOptionState({ nav: "dashboard", page: "main" });
    }
  }, [mobileTablet]);

  useEffect(() => {
    if (freeUser && PREMIUM_PAGES.find((page) => page === optionState.nav)) {
      setOptionState({ nav: "dashboard", page: "main" });
    }
  }, [optionState.nav]);

  return (
    <>
      <PageWrapper
        render
        display={optionState.nav === "dashboard"}
        currentPage={optionState.nav}>
        <Dashboard />
      </PageWrapper>
      <PageWrapper
        display={optionState.nav === "stats"}
        currentPage={optionState.nav}>
        <Stats />
      </PageWrapper>
      <PageWrapper
        display={optionState.nav === "tryps" && !freeUser}
        currentPage={optionState.nav}>
        <Tryps />
      </PageWrapper>
      <PageWrapper
        display={optionState.nav === "sponsorZone"}
        currentPage={optionState.nav}>
        <SponsorZone />
      </PageWrapper>
      <PageWrapper
        display={optionState.nav === "levelUp" && !freeUser}
        currentPage={optionState.nav}>
        <LevelUp />
      </PageWrapper>
      <PageWrapper
        render
        display={optionState.nav === "competitionInfo"}
        currentPage={optionState.nav}>
        <CompetitionInfo />
      </PageWrapper>
      <PageWrapper
        render
        display={optionState.nav === "safeRoads"}
        currentPage={optionState.nav}>
        <SafeRoads />
      </PageWrapper>
    </>
  );
};

export default Home;
